import React from 'react';
import { useTypewriter } from 'react-simple-typewriter';
import oneImage from './one.jpg';
import mineImage from './mine.png';
import foot from './football.jpg';

const About = () => {
  const [typeEffect] = useTypewriter({
    words: ['Sahil Jogi'],
    loop: {},
    typeSpeed: 100,
    delaySpeed: 30
  });

  const [typeEffect1] = useTypewriter({
    words: ['Sahilminecraft502@gamil.com'],
    loop: {},
    typeSpeed: 100,
    delaySpeed: 30
  });

  const [typeEffect2] = useTypewriter({
    words: ['Coding, Football'],
    loop: {},
    typeSpeed: 100,
    delaySpeed: 30
  });

  const [typeEffect3] = useTypewriter({
    words: ['14(fourteen)'],
    loop: {},
    typeSpeed: 100,
    delaySpeed: 30
  });

  return (
    <div style={{ marginTop: '100px', display: "flex",  marginLeft: '30px' }}>
      <div className='left' style={{ height: '100vh', width: '50%', padding: '10px' }}>
        <h2><u>ItxSahil</u></h2>
        <p>This is a personal website of Sahil Jogi. This website is made using React JS by Sahil Jogi. In this website
          there are some projects of Sahil.
        </p>
        <div style={{ display: "flex", alignItems: "center" }}>
          <a href="https://www.facebook.com/profile.php?id=100086642529053">
            <i className="fa-brands fa-facebook" style={{ fontSize: '30px', color: 'black', marginLeft: '5px' }}></i>
          </a>
          <a href="https://www.instagram.com/itx_sahil1110?igsh=MXc4M2xqNXlkOGVNw==">
            <i className="fa-brands fa-instagram" style={{ fontSize: '30px', color: 'black', marginLeft: '5px' }}></i>
          </a>
        </div>
        <h3 style={{ marginTop: '20px' }}><u>Personal Details</u></h3>
        <ul>
          <li style={{ fontWeight: '800', fontSize: '18px' }}><s style={{ color: 'green' }}>Name:  </s> {typeEffect}</li>
          <li style={{ fontWeight: '800', fontSize: '18px' }}><s style={{ color: 'green' }}>Gmail:  </s> {typeEffect1}</li>
          <li style={{ fontWeight: '800', fontSize: '18px' }}><s style={{ color: 'green' }}>Hobby:  </s> {typeEffect2}</li>
          <li style={{ fontWeight: '800', fontSize: '18px' }}><s style={{ color: 'green' }}>Age:  </s> {typeEffect3}</li>
        </ul>
      </div>
      <div className='right' style={{ height: '100vh', width: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div id="carouselExampleIndicators" className="carousel slide">
          <div className="carousel-indicators">
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
          </div>
          <div className="carousel-inner" style={{ borderRadius: '20px' }}>
            <div className="carousel-item active">
              <img src={oneImage} className="d-block w-100" alt="Not Found" />
            </div>
            <div className="carousel-item">
              <img src={foot} className="d-block w-100" alt="Not Found" />
            </div>
            <div className="carousel-item">
              <img src={mineImage} className="d-block w-100" alt="Not Found" />
            </div>
          </div>
          <button className="carousel-control-next my-4" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next" style={{ backgroundColor: 'green'}}>
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default About;
